export const defaultOfficeRfe = {
	title: "Cabinet de réception de vos factures RFE",
	intro: "Dans le cadre de la facturation électronique, lorsqu’une facture reçue ne peut pas être rattachée automatiquement à un cabinet, le cabinet défini par défaut sera utilisé afin de permettre son affectation.",
	lead: "Choisissez votre cabinet par défaut",
	note: "Vous pourrez modifier ce choix ultérieurement.",
	confirm: "valider mon choix",
	later: "plus tard",
	success: "Votre cabinet de réception des factures RFE a bien été enregistré.",
	failed: "L'enregistrement du cabinet a échoué. Veuillez réessayer."
}
